// feel free to rename if you think of something better
// other possible names: SingleOrMulti, MultiplicityType, CountType, etc

// this would technically be 0-dimension vs 1-dimension
export enum DimensionalType {
  Single = 1,
  Multi = 2
}